var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8 1.5C1.72044 1.5 1.64413 1.53161 1.58787 1.58787C1.53161 1.64413 1.5 1.72044 1.5 1.8V6.525C1.5 6.60456 1.53161 6.68087 1.58787 6.73713C1.64413 6.79339 1.72044 6.825 1.8 6.825H2.325C2.73921 6.825 3.075 7.16079 3.075 7.575C3.075 7.98921 2.73921 8.325 2.325 8.325H1.8C1.32261 8.325 0.864773 8.13536 0.527208 7.79779C0.189642 7.46023 0 7.00239 0 6.525V1.8C0 1.32261 0.189642 0.864773 0.527208 0.527208C0.864773 0.189642 1.32261 0 1.8 0H6.525C7.00239 0 7.46023 0.189642 7.79779 0.527208C8.13536 0.864773 8.325 1.32261 8.325 1.8V2.325C8.325 2.73921 7.98921 3.075 7.575 3.075C7.16079 3.075 6.825 2.73921 6.825 2.325V1.8C6.825 1.72044 6.79339 1.64413 6.73713 1.58787C6.68087 1.53161 6.60456 1.5 6.525 1.5H1.8ZM5.475 5.175C5.30931 5.175 5.175 5.30931 5.175 5.475V10.2C5.175 10.3657 5.30931 10.5 5.475 10.5H10.2C10.3657 10.5 10.5 10.3657 10.5 10.2V5.475C10.5 5.30931 10.3657 5.175 10.2 5.175H5.475ZM3.675 5.475C3.675 4.48089 4.48089 3.675 5.475 3.675H10.2C11.1941 3.675 12 4.48089 12 5.475V10.2C12 11.1941 11.1941 12 10.2 12H5.475C4.48089 12 3.675 11.1941 3.675 10.2V5.475Z",
    fill: "#1F2445"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyClipboard);
export default __webpack_public_path__ + "static/media/copyClipboard.fe4de78d688374cbecd1a8e38b2d04f6.svg";
export { ForwardRef as ReactComponent };